import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'
// module
import TypeText from './TypeText'
import TypeTextImage from './TypeTextImage'
import TypeTextMovie from './TypeTextMovie'
import TypePdf from './TypePdf'
import TypeSound from './TypeSound'
import TypeOpinionaire from './TypeOpinionaire'
import TypeSoundBroadcast from './TypeSoundBroadcast'
import TypeImage from './TypeImage'
import TypeMovie from './TypeMovie'
import TypeKeikai from './TypeKeikai'
import TypeEmergency from './TypeEmergency'
import TypeImportant from './TypeImportant'
import TypeRapidInfo from './TypeRapidInfo'
import TypeRapidNotice from './TypeRapidNotice'

export default {
  name: 'NoticeInput',
  components: {
    Datepicker,
    // module
    TypeText,
    TypeTextImage,
    TypeTextMovie,
    TypePdf,
    TypeSound,
    TypeOpinionaire,
    TypeSoundBroadcast,
    TypeImage,
    TypeMovie,
    TypeKeikai,
    TypeEmergency,
    TypeImportant,
    TypeRapidInfo,
    TypeRapidNotice
  },
  data () {
    return {
      valid: false,

      // 即時配信
      immediateEndDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: null,
          from: null
        }
      },
      // 予約配信
      reservedStartDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: null,
          from: null
        }
      },
      reservedEndDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: null,
          from: null
        }
      },
      // 繰り返し配信
      repeatedStartDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: null,
          from: null
        }
      },
      repeatedEndDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: null,
          from: null
        }
      },

      // input
      inpDeliveryPatternAll: false,
    }
  },
  mounted () {
    this.valid = this.values.inpService &&
      this.values.inpDeliveryType &&
      this.values.inpNoticeType;

    // ページのリロードなど、前ページの選択情報が保持されていない場合は
    if (this.valid) {
      this.init()
      console.log('values', this.values)

    } else {
      this.$router.push({
        name: 'NoticeSelector',
        params: {
          noticeId: Constants.RegisterHash
        }
      });
      return;
    }
  },
  computed: {
    ...mapState({
      categoryName: state => state.notice.categoryName,

      // model
      serviceModel: state => state.noticeForm.serviceModel,
      deliveryTypeMstModel: state => state.noticeForm.deliveryTypeMstModel,
      serviceAttributeModel: state => state.noticeForm.serviceAttributeModel,
      noticeTypeMstModel: state => state.noticeForm.noticeTypeMstModel,
      serviceDetailModel: state => state.noticeForm.serviceDetailModel,

      // form
      userIdentity: state => state.noticeForm.targetId,
      values: state => state.noticeForm.values,
      validate: state => state.noticeForm.validate,

      // ロケーションのニックネーム
      locationNickname: state => state.noticeForm.locationNickname,
    }),
    ...mapGetters({
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      permittedView: 'permission/permittedView',
      isRegister: 'noticeForm/isRegister',
      isModify: 'noticeForm/isModify',
      noticeType: 'noticeForm/noticeType',
      deliveryType:'noticeForm/deliveryType'
    }),

    // result
    showResultCommunity () {
      // 配信先設定が「全配信:0」以外
      // return this.values.inpTarget !== 0
      return true
    },
    resutCommunity () {
      return this.isAdmin
        ? this.serviceModel
          .find(item => item.serviceUuid === this.values.inpService).communityName
        : this.serviceDetailModel.communityName
    },
    resultTarget () {
      const type = Utility.getConstantsLabel(['ContentsApply', 'DeliveryToKbn'], this.values.inpTarget)

      // 全配信
      if (this.values.inpTarget === 0) {
        return type
      // 属性配信
      } else if (this.values.inpTarget === 1) {
        let list = []
        this.serviceAttributeModel.filter(type => {
          type.attributeGroups
            .filter(item => this.values.inpAttribute.indexOf(item.attributeGroupUuid) !== -1)
            .forEach(item => {
              list.push(type.attributeTypeName + ' : ' + item.attributeGroupName)
            })
          return true
        })
        return type + '（' + (list.length ? list.join('、') : '') + '）'

      // 個別配信
      } else {
        return type + '（' + this.locationNickname + '）'
      }
    },
    resultDeliveryType () {
      return Utility.getObjectArrayValue(this.deliveryTypeMstModel, 'deliveryTypeMstUuid', this.values.inpDeliveryType, 'deliveryTypeName')
    },

    // list
    deliveryPlanTypeList () {
      switch(this.noticeType) {
        case 'opinionaire':
          return Constants.Notice.DeliveryPlanType.filter(item => item.value !== 3)
        case 'sound_broadcast':
          return Constants.Notice.DeliveryPlanType.filter(item => item.value === 3)
        case 'keikai':
          return Constants.Notice.DeliveryPlanType.filter(item => item.value === 1)
        case 'rapid_info':
          return Constants.Notice.DeliveryPlanType.filter(item => item.value === 1)
        case 'important_notice':
          return this.deliveryType === 'rapid_notice'
            ? Constants.Notice.DeliveryPlanType.filter(item => item.value === 1)
            : Constants.Notice.DeliveryPlanType
        default:
          return Constants.Notice.DeliveryPlanType
      }
    },
    deliveryPatternList () {
      const array = $.extend(true, [], Constants.Notice.DeliveryPattern);
      return array.sort(Utility.sortByKey('index', true))
    },
    hoursList () {
      return Constants.Hours
    },
    minutesList () {
      return Constants.Minutes
    },

    // input
    inpAuthor: {
      get () {
        return this.values.inpAuthor
      },
      set (value) {
        this.setInputValue({
          key: 'inpAuthor',
          value: value
        })
      }
    },
    inpDeliveryPlanType: {
      get () {
        return this.values.inpDeliveryPlanType
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryPlanType',
          value: value
        })
      }
    },
    // 即時配信
    inpImmediateDeliveryEndDate: {
      get () {
        return this.values.inpImmediateDeliveryEndDate
      },
      set (value) {
        this.setInputValue({
          key: 'inpImmediateDeliveryEndDate',
          value: value
        })
      }
    },
    inpImmediateDeliveryEndHours: {
      get () {
        return this.values.inpImmediateDeliveryEndHours
      },
      set (value) {
        this.setInputValue({
          key: 'inpImmediateDeliveryEndHours',
          value: value
        })
      }
    },
    inpImmediateDeliveryEndMinutes: {
      get () {
        return this.values.inpImmediateDeliveryEndMinutes
      },
      set (value) {
        this.setInputValue({
          key: 'inpImmediateDeliveryEndMinutes',
          value: value
        })
      }
    },
    // 予約配信
    inpReservedDeliveryStartDate: {
      get () {
        return this.values.inpReservedDeliveryStartDate
      },
      set (value) {
        this.setInputValue({
          key: 'inpReservedDeliveryStartDate',
          value: value
        })
      }
    },
    inpReservedDeliveryStartHours: {
      get () {
        return this.values.inpReservedDeliveryStartHours
      },
      set (value) {
        this.setInputValue({
          key: 'inpReservedDeliveryStartHours',
          value: value
        })
      }
    },
    inpReservedDeliveryStartMinutes: {
      get () {
        return this.values.inpReservedDeliveryStartMinutes
      },
      set (value) {
        this.setInputValue({
          key: 'inpReservedDeliveryStartMinutes',
          value: value
        })
      }
    },
    inpReservedDeliveryEndDate: {
      get () {
        return this.values.inpReservedDeliveryEndDate
      },
      set (value) {
        this.setInputValue({
          key: 'inpReservedDeliveryEndDate',
          value: value
        })
      }
    },
    inpReservedDeliveryEndHours: {
      get () {
        return this.values.inpReservedDeliveryEndHours
      },
      set (value) {
        this.setInputValue({
          key: 'inpReservedDeliveryEndHours',
          value: value
        })
      }
    },
    inpReservedDeliveryEndMinutes: {
      get () {
        return this.values.inpReservedDeliveryEndMinutes
      },
      set (value) {
        this.setInputValue({
          key: 'inpReservedDeliveryEndMinutes',
          value: value
        })
      }
    },
    // 繰り返し配信
    inpDeliveryPattern: {
      get () {
        return this.values.inpDeliveryPattern
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryPattern',
          value: value
        })
      }
    },
    inpRepeatedDeliveryStartDate: {
      get () {
        return this.values.inpRepeatedDeliveryStartDate
      },
      set (value) {
        this.setInputValue({
          key: 'inpRepeatedDeliveryStartDate',
          value: value
        })
      }
    },
    inpRepeatedDeliveryStartHours: {
      get () {
        return this.values.inpRepeatedDeliveryStartHours
      },
      set (value) {
        this.setInputValue({
          key: 'inpRepeatedDeliveryStartHours',
          value: value
        })
      }
    },
    inpRepeatedDeliveryStartMinutes: {
      get () {
        return this.values.inpRepeatedDeliveryStartMinutes
      },
      set (value) {
        this.setInputValue({
          key: 'inpRepeatedDeliveryStartMinutes',
          value: value
        })
      }
    },
    inpRepeatedDeliveryEndDate: {
      get () {
        return this.values.inpRepeatedDeliveryEndDate
      },
      set (value) {
        this.setInputValue({
          key: 'inpRepeatedDeliveryEndDate',
          value: value
        })
      }
    },
    // inpRepeatedDeliveryEndHours: {
    //   get () {
    //     return this.values.inpRepeatedDeliveryEndHours
    //   },
    //   set (value) {
    //     this.setInputValue({
    //       key: 'inpRepeatedDeliveryEndHours',
    //       value: value
    //     })
    //   }
    // },
    // inpRepeatedDeliveryEndMinutes: {
    //   get () {
    //     return this.values.inpRepeatedDeliveryEndMinutes
    //   },
    //   set (value) {
    //     this.setInputValue({
    //       key: 'inpRepeatedDeliveryEndMinutes',
    //       value: value
    //     })
    //   }
    // },

    // enable : 即時配信
    disableImmediateDeliveryEndTime () {
      return this.inpImmediateDeliveryEndDate === null
    },
    // enable : 予約配信
    disableReservedDeliveryStartTime () {
      return this.inpReservedDeliveryStartDate === null
    },
    disableReservedDeliveryEndTime () {
      return this.inpReservedDeliveryEndDate === null
    },
    // enable : 繰り返し配信
    disableDeliveryPatternAll () {
      return this.inpDeliveryPattern.reduce((sum, element) => sum + element, 0) === 127
    },
    disableRepeatedDeliveryStartTime () {
      return this.inpRepeatedDeliveryStartDate === null
    },
    // disableRepeatedDeliveryEndTime () {
    //   return this.inpRepeatedDeliveryEndDate === null
    // },

    inpImmediateDeliveryEndIsValid () {
      return Validator.validDate(this.inpImmediateDeliveryEndDate) &&
        Validator.validSelect(this.inpImmediateDeliveryEndHours) &&
        Validator.validSelect(this.inpImmediateDeliveryEndMinutes)
    },
    inpReservedDeliveryStartIsValid () {
      return Validator.validDate(this.inpReservedDeliveryStartDate) &&
        Validator.validSelect(this.inpReservedDeliveryStartHours) &&
        Validator.validSelect(this.inpReservedDeliveryStartMinutes)
    },
    inpReservedDeliveryEndIsValid () {
      return Validator.validDate(this.inpReservedDeliveryEndDate) &&
        Validator.validSelect(this.inpReservedDeliveryEndHours) &&
        Validator.validSelect(this.inpReservedDeliveryEndMinutes)
    },
    inpDeliveryPatternIsValid () {
      return Validator.validArray(this.inpDeliveryPattern)
    },
    inpRepeatedDeliveryStartIsValid () {
      return Validator.validDate(this.inpRepeatedDeliveryStartDate) &&
        Validator.validSelect(this.inpRepeatedDeliveryStartHours) &&
        Validator.validSelect(this.inpRepeatedDeliveryStartMinutes)
    },
    inpRepeatedDeliveryEndIsValid () {
      return Validator.validDate(this.inpRepeatedDeliveryEndDate)
    },
    // validate
    formIsValid () {
      const f1 = Validator.validText(this.inpAuthor) &&
        Validator.validRadio(this.inpDeliveryPlanType) &&
        this.validate
      if (this.inpDeliveryPlanType === 1) {
        return f1
      } else if (this.inpDeliveryPlanType === 2) {
        return f1 &&
          this.inpReservedDeliveryStartIsValid
      } else {
        return f1 &&
          this.inpDeliveryPatternIsValid &&
          this.inpRepeatedDeliveryStartIsValid &&
          this.inpRepeatedDeliveryEndIsValid
      }
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    inpAuthor: function(to) {
      if (to) {
        this.inpAuthor = Validator.charByteLimit(to, 20)
      }
    },
    inpDeliveryPlanType: function (to) {
      // 日付や繰り返しの初期化
      // 即時配信
      this.inpImmediateDeliveryEndDate = null
      this.inpImmediateDeliveryEndHours = ''
      this.inpImmediateDeliveryEndMinutes = ''
      // 予約配信
      this.inpReservedDeliveryStartDate = null
      this.inpReservedDeliveryStartHours = ''
      this.inpReservedDeliveryStartMinutes = ''
      this.inpReservedDeliveryEndDate = null
      this.inpReservedDeliveryEndHours = ''
      this.inpReservedDeliveryEndMinutes = ''
      // 繰り返し配信
      this.inpDeliveryPattern = []
      this.inpRepeatedDeliveryStartDate = null
      this.inpRepeatedDeliveryStartHours = ''
      this.inpRepeatedDeliveryStartMinutes = ''
      this.inpRepeatedDeliveryEndDate = null
      // this.inpRepeatedDeliveryEndHours = ''
      // this.inpRepeatedDeliveryEndMinutes = ''
    },
    inpDeliveryPattern: function (to) {
      this.inpDeliveryPatternAll = to.reduce((sum, element) => sum + element, 0) === 127
      // console.log('value: ', to)
      // let n = to.reduce((sum, element) => sum + element, 0)
      // console.log('sum: ', n)
      // let array = Utility.bitArrayByInt(n)
      // console.log('bitArray: ', array)
      // let n2 = Utility.intByBitArray(array)
      // console.log('n2: ', n2)
    },
    inpDeliveryPatternAll: function (to) {
      if (to) {
        this.inpDeliveryPattern = this.deliveryPatternList
          .map(item => item.value)
      }
    }
  },
  methods: {
    ...mapActions({

    }),
    ...mapMutations({
      setValues: 'noticeForm/setValues',
      setInputValue: 'noticeForm/setInputValue'
    }),

    init () {

    },
    turnBack () {
      this.$router.go(-1)
    },

    // モジュールの表示設定
    showModule (type) {
      const mst = this.noticeTypeMstModel.filter(item => item.noticeTypeMstUuid === this.values.inpNoticeType)
      if (!mst.length) return false
      return mst[0].noticeType === type
      // switch (type) {
      //   case 'text':
      //     return this.values.inpNoticeType === 'noticeType001'
      //   case 'text_image':
      //     return this.values.inpNoticeType === 'noticeType002'
      //   case 'text_movie':
      //     return this.values.inpNoticeType === 'noticeType003'
      //   case 'pdf':
      //     return this.values.inpNoticeType === 'noticeType004'
      //   case 'sound':
      //     return this.values.inpNoticeType === 'noticeType005'
      //   case 'opinionaire':
      //     return this.values.inpNoticeType === 'noticeType006'
      //   case 'sound_broadcast':
      //     return this.values.inpNoticeType === 'noticeType007'
      //   case 'image':
      //     return this.values.inpNoticeType === 'noticeType008'
      //   case 'movie':
      //     return this.values.inpNoticeType === 'noticeType009'
      //   case 'keikai':
      //     return this.values.inpNoticeType === 'noticeType012'
      //   default:
      //     return false
      // }
    },

    // 即時配信
    changeImmediateDeliveryEndDate (value) {
      if (value === null) return
      let dateObj = new Date(value)
      this.inpImmediateDeliveryEndDate = new Date(dateObj.setHours(0,0,0,1))
    },
    // 予約配信
    changeReservedDeliveryStartDate (value) {
      if (value === null) return
      let dateObj = new Date(value)
      this.inpReservedDeliveryStartDate = new Date(dateObj.setHours(0,0,0,1))
      this.reservedEndDateOptions.disabledDates.to = moment(this.inpReservedDeliveryStartDate).toDate()
    },
    changeReservedDeliveryEndDate (value) {
      if (value === null) return
      let dateObj = new Date(value)
      this.inpReservedDeliveryEndDate = new Date(dateObj.setHours(0,0,0,1))
      this.reservedStartDateOptions.disabledDates.from = moment(this.inpReservedDeliveryEndDate).toDate()
    },
    // 対象期間
    changeRepeatedDeliveryStartDate (value) {
      if (value === null) return
      let dateObj = new Date(value)
      this.inpRepeatedDeliveryStartDate = new Date(dateObj.setHours(0,0,0,1))
      this.repeatedEndDateOptions.disabledDates.to = moment(this.inpRepeatedDeliveryStartDate).toDate()
    },
    changeRepeatedDeliveryEndDate (value) {
      if (value === null) return
      let dateObj = new Date(value)
      this.inpRepeatedDeliveryEndDate = new Date(dateObj.setHours(0,0,0,1))
      this.repeatedStartDateOptions.disabledDates.from = moment(this.inpRepeatedDeliveryEndDate).toDate()
    },

    confirmData () {
      if (!this.formIsValid) return

      // console.log('module', this.$refs.module.input)
      this.setInputValue({
        key: 'inpDeliveryContents',
        value: this.$refs.module.jsonb || this.$refs.module.input
      })

      // 確認画面に遷移
      this.$router.push({
        name: 'NoticeConfirm'
      })
    }
  }
}
